import React, { useState } from 'react';

import Editor from '@qality/common-components/src/editor';
import { InputUtils } from '@qality/common-utils';

import './_test-step-input.scss';

type Props = {
  onChange: (value: string) => void;
  autofocus: boolean;
};

export default function TestStepInput({
  autofocus,
  onChange,
}: Props): JSX.Element {
  const [isFocused, setIsFocused] = useState(autofocus);

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleClick = () => {
    setIsFocused(true);
  };

  const handleOnChange = (text: string) => {
    onChange(InputUtils.keepEmptyLines(text));
  };

  return (
    <div className='test-step-input'>
      <div>
        <Editor
          onClick={handleClick}
          onBlur={handleBlur}
          onChange={handleOnChange}
          isDisabled={false}
          isFocused={isFocused}
          listEnabled={true}
        />
      </div>
    </div>
  );
}
